import { useTracking } from 'react-tracking';

import loadable from '@loadable/component';

import { useMount } from '@simplywallst/ui-core';

import { OneColumn } from '@/components/Layout';
import DocumentHeader from '@/components/DocumentHeader';

import { CompanyNoteModalProvider } from '@/components/Note';
import { ManualPortfolioProvider } from '../../components/PortfolioManual';
import { DEMO_PORTFOLIO_ID } from '@/constants';
import { usePortfolio } from '@/hooks/portfolio/usePortfolio';

const ErrorState = loadable(() => import('../../components/ErrorState'), {
  resolveComponent: (c) => c.ErrorState,
});

const PopulatedState = loadable(() => import('./components/PopulatedState'), {
  resolveComponent: (c) => c.PopulatedState,
});

export const DemoPortfolio = () => {
  const { status, data: portfolio } = usePortfolio({
    id: DEMO_PORTFOLIO_ID,
  });

  const { Track, trackEvent } = useTracking({
    type: 'track',
    subject: 'page',
  });

  const holdings = portfolio?.holdings ?? [];

  const isEmpty = status === 'success' && portfolio && holdings.length === 0;
  const isError =
    status === 'error' || (status === 'success' && !portfolio) || isEmpty;
  const isPopulated = status !== 'error' && portfolio && holdings.length > 0;

  useMount(() => {
    trackEvent({ action: 'landed' });
  });

  if (isError) {
    return (
      <Track>
        <DocumentHeader title="Demo Portfolio" allowCrawlers={false} />
        <OneColumn>
          <ErrorState />
        </OneColumn>
      </Track>
    );
  }

  if (isPopulated) {
    return (
      <Track>
        <DocumentHeader title="Demo Portfolio" allowCrawlers={false} />
        <ManualPortfolioProvider>
          <CompanyNoteModalProvider>
            <PopulatedState portfolio={portfolio} />
          </CompanyNoteModalProvider>
        </ManualPortfolioProvider>
      </Track>
    );
  }

  return null;
};
